import { render } from "./AboutUsBlue.vue?vue&type=template&id=3bda9b32&lang=pug"
import script from "./AboutUsBlue.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutUsBlue.vue?vue&type=script&setup=true&lang=js"

import "./AboutUsBlue.vue?vue&type=style&index=0&id=3bda9b32&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__